export const initialState = {
  rows: [],
  loading: false,
  error: null,
  message: "",
  status: null
};
